import { IFormatPriceOptions } from "./types";

const COMMON_OPTIONS: IFormatPriceOptions = {
  locale: "en-US",
  style: "currency",
  currency: "USD",
};

export const DEFAULT_FORMAT_PRICE_OPTIONS: IFormatPriceOptions = {
  ...COMMON_OPTIONS,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  roundUp: true,
};

export const NUMBER_FORMAT_PRICE_OPTIONS: IFormatPriceOptions = {
  ...COMMON_OPTIONS,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  roundUp: true,
};

// for precise rates (e.g. $0.000002 per row, or $99.999): show the exact value without
// ceiling, with enough precision to render sub-cent prices.
export const PRECISE_FORMAT_PRICE_OPTIONS: IFormatPriceOptions = {
  ...COMMON_OPTIONS,
  minimumFractionDigits: 2,
  maximumFractionDigits: 12,
  roundUp: false,
};
